import { FeatureFlagsContext } from "components/providers/featureFlags/featureFlagContext";
import { getInitialFeatureFlagState } from "components/providers/featureFlags/getInitialFeatureFlagState";
import { useState } from "react";

export const FeatureFlagsProvider: React.FCWithChildren = ({ children }) => {
    const searchParams = new URLSearchParams(window.location.search);
    const state = useState(getInitialFeatureFlagState(searchParams));
    
    return (
        <FeatureFlagsContext.Provider value={state}>
            {children}
        </FeatureFlagsContext.Provider>
    );
};
